import { css } from "@emotion/react"
import { Icon } from "source/shared/components/Icon"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { RepeatableFrequency } from "../types"
import { frequencyToSummary } from "../utils/frequency"

export function FrequencySummary({
  frequency,
}: {
  frequency: RepeatableFrequency
}) {
  const { dispatch } = useDonationFormContext()
  const summary = frequencyToSummary(frequency)

  const handleEdit = () => dispatch({ type: "EXPAND_EDIT_FREQUENCY" })

  return (
    <div className="d-f jc-sb ai-c g-1" data-testid="frequency-summary">
      <span>
        {summary.prefix} <strong>{summary.date}</strong> starting{" "}
        <strong>{summary.starting}</strong>
      </span>
      <button
        type="button"
        onClick={handleEdit}
        className="btn link-btn px-1 circle"
        aria-label="Edit recurrence date(s)"
        css={css`
          aspect-ratio: 1;
        `}
      >
        <Icon symbol="general#pencil" aria-hidden />
      </button>
    </div>
  )
}
